import * as React from 'react';
import * as styles from '../styles/notificationStyles';
import { Formatters, Messages } from '../../codegen/Localize';
import { NotificationIcon } from './NotificationIcon';
import { UserNotificationType } from '../contentProviders/UserNotificationType';
import { NotificationActions } from './NotificationActions';
import { NotificationAction } from '../contentProviders/INotificationProvider';
import { Keys } from '../../ts/helpers/Keys';
import * as ReactMarkdown from 'react-markdown';

export interface NotificationProps {
  id: string;
  displayName: string;
  notificationType: UserNotificationType;
  profileImageUrl: string;
  createdAt: Date;
  isRead: boolean;
  title?: string;
  content: string;
  notificationActions: Array<NotificationAction>;
  onKeyDown: (e: any) => void;
  onNotificationClick: () => void;
}

/**
 * Notification component representing a single notification
 */
export class Notification extends React.PureComponent<NotificationProps> {

  constructor(props: NotificationProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <div role='row' style={styles.notificationItemRow} data-tb-test-id={`notification-row-${this.props.id}`}>
        <div
          role='gridcell'
          data-tb-test-id={`notification-${this.props.id}`}
          id={`notification-${this.props.id}`}
          className={styles.notificationItem}
          tabIndex={0}
          onClick={this.handleClick}
          onKeyDown={this.props.onKeyDown}
        >
          <div className={styles.notificationContainer}>
            <div style={styles.profileContainer}>
              <div style={styles.blueDotCss(!this.props.isRead)} />
              <NotificationIcon
                imageUrl={this.props.profileImageUrl}
                notificationType={this.props.notificationType}
                displayName={this.props.displayName} />
            </div>
            <div style={styles.notificationContentContainer}>
              <div style={styles.contentHeader}>
                <span className='notification-create-time' style={styles.createdAt}>
                  {Formatters.formatMediumDateTimeWithoutSeconds(this.props.createdAt)}
                </span>
              </div>
              <div style={styles.notificationTitle}>
                <ReactMarkdown source={this.props.title} escapeHtml={true} renderers={{ paragraph: 'div' }} />
              </div>
              <div style={styles.notificationContent}>
                <ReactMarkdown source={this.props.content} escapeHtml={true} renderers={{ paragraph: 'div' }} />
              </div>
            </div>
          </div>
        </div>
        <NotificationActions notificationId={this.props.id} actions={this.props.notificationActions} onKeyDown={this.handleActionKeyDown} />
      </div>
    );
  }

  private handleClick = (): void => {
    this.props.onNotificationClick();
  }

  private handleActionKeyDown: React.KeyboardEventHandler<HTMLButtonElement> = e => {
    if (e.keyCode === Keys.ArrowLeft) {
      e.preventDefault();
      e.stopPropagation();
      const selector = '.' + styles.notificationItem;
      const notificationItem = e.currentTarget.parentElement.parentElement.querySelector<HTMLDivElement>(selector);
      notificationItem.focus();
    }
  }
}